import ServiceCRUD from '../../../services/ServiceCRUDFLEXCHAT';

class QueueMessageService extends ServiceCRUD {
  constructor() {
    super('mensagemFila');
  }
}

export default new QueueMessageService();
